import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M14.013 8.404a.969.969 0 0 0-1.37-1.37L4.186 15.49c-.759.757-1.327 1.324-1.632 2.061s-.305 1.54-.304 2.612v1.117c0 .535.434.969.969.969h1.117c1.072 0 1.875.001 2.612-.304s1.304-.873 2.061-1.632l8.457-8.457a.969.969 0 0 0-1.37-1.37l-2.363 2.363c-.086.087-.13.13-.185.153s-.116.023-.239.023h-2.47c-.616 0-.925 0-1.001-.185-.077-.185.14-.403.577-.84z",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M14.895 3.032a.964.964 0 1 0-1.363 1.363l6.573 6.573a.964.964 0 1 0 1.363-1.363l-.922-.922a.17.17 0 0 1 0-.24l.03-.03.042-.042c.24-.24.422-.421.556-.61a2.745 2.745 0 0 0 0-3.184c-.134-.188-.316-.37-.556-.609l-.086-.087c-.24-.24-.421-.42-.61-.555a2.745 2.745 0 0 0-3.184 0c-.188.134-.37.316-.609.556l-.043.043-.029.029a.17.17 0 0 1-.24 0z"
    }, null, -1)
  ])))
}
export default { render: render }